import MuiTooltip from "@mui/material/Tooltip";
import type { TooltipProps } from "@mui/material/Tooltip";
import type { FunctionComponent } from "react";

export type Props = TooltipProps;
export { tooltipClasses } from "@mui/material/Tooltip";

export const Tooltip: FunctionComponent<Props> = ({ children, className, ...props }) => (
  <MuiTooltip {...props} classes={{ popper: className }}>
    {children}
  </MuiTooltip>
);

Tooltip.displayName = "Tooltip";
